import axiosClient from "./axiosClient";

export async function trackUserEvent(eventType, { productId, categoryId, searchText, latitude, longitude } = {}) {
  try {
    await axiosClient.post("/UserEvents/track", { eventType, productId, categoryId, searchText, latitude, longitude });
  } catch {
    // Best-effort analytics call; a failure here shouldn't affect the user's flow.
  }
}
